const UI_ROUTE = "/ui";
export const ROOT = `${UI_ROUTE}/`;
export const FORECAST_REPORT = `${UI_ROUTE}/forecastreport`;
export const BEST_SELLERS = `${UI_ROUTE}/bestsellers`;
export const OVERSTOCK = `${UI_ROUTE}/overstock`;
export const AUTH = `${UI_ROUTE}/auth`;
export const ERROR = `${UI_ROUTE}/error`;
export const CONNECTING = `${UI_ROUTE}/connecting`;
export const FORECASTING = `${UI_ROUTE}/forecasting`;
export const PROFILE = `${UI_ROUTE}/settings`;
export const INCOMING_INVENTORY = `${UI_ROUTE}/incominginventory`;
/*
 * Must stay a child of INCOMING_INVENTORY (`/ui/incominginventory/add`).
 * App Bridge highlights the nav item only when the current pathname is that
 * href or a path underneath it. `/ui/incominginventoryadd` is a sibling, so
 * Incoming Inventory stays inactive and the home Dashboard (`/ui/`) wins.
 *
 * Example: /ui/incominginventory/add → Incoming Inventory active
 */
export const IMPORT_INCOMING_INVENTORY = `${UI_ROUTE}/incominginventory/add`;
export const LEGACY_IMPORT_INCOMING_INVENTORY = `${UI_ROUTE}/incominginventoryadd`;
export const HELP = `${UI_ROUTE}/help`;
export const SHOP_REDIRECT = `${UI_ROUTE}/shop-redirect`;
export const UPGRADE_BILLING_PLAN = `${UI_ROUTE}/upgradeplan`;
export const ONBOARDING = `${UI_ROUTE}/onboarding`;
export const ONBOARDING_BILLING_PLAN = `${ONBOARDING}/billingplan`;
export const ONBOARDING_DOWNGRADE_PLAN = `${ONBOARDING}/downgradeplan`;
export const ONBOARDING_EMAIL_SETUP = `${ONBOARDING}/emailsetup`;
export const ONBOARDING_PROFILE_SETUP = `${ONBOARDING}/profilesetup`;
export const ONBOARDING_SETUP_STATUS = `${ONBOARDING}/setup`;
export const PRIVACY = `${UI_ROUTE}/privacy`;
export const TERMS = `${UI_ROUTE}/terms`;
export const CHATBOT = `${UI_ROUTE}/chatbot`;
